const Moon = container => {
  const app = document.getElementById(container);
  const render = stuff => (app.innerHTML = stuff);
  const wait = (time = 1000) =>
    new Promise(resolve => setTimeout(resolve, time));

  const project = emoji => {
    render(emoji);
    document.title = `orion.space ${emoji}`;
  };

  // ["🌕", "🌖", "🌗", "🌘", "🌑", "🌒", "🌓", "🌔"];
  const phases = "🌕 🌖 🌗 🌘 🌑 🌒 🌓 🌔".split(" "); // but, why? #hmm ;)

  let phase = 0;
  const animate = async (delay = 500) => {
    await wait(delay);

    // render(phases[phase]);
    // document.title = `orion.space ${phases[phase]}`;
    project(phases[phase]);

    phase = (phase + 1) % phases.length;
    animate();
  };

  const run = async () => {
    project("🚀");
    await wait(1000);
    project("🌌");
    await wait(300);
    animate();
  };

  return { render, run, animate, app };
};

export default Moon;
